import React, { Component } from "react";
import MetaTags from 'react-meta-tags';
import { translate } from "react-i18next";
import Footer from "../layout/footer";

class labs extends Component {
    state = {
    }

    componentDidMount() {
        var path = window.location.pathname
        path = path.slice(1, 3);
        if (path === 'en') {
          require("./lab.css");
        } else if (path === 'sc') {
          require("./lab_sc.css");
        } else if (path === 'tc') {
          require("./lab_tc.css");
        }
    }
    render() {
        const { t } = this.props;
        return (
            <div className="d-flex justify-content-center">
                <MetaTags>
                    <title>{t('lab-meta-title')}</title>
                    <meta name="title" content={t('lab-meta-title')} />
                    <meta name="description" content={t('lab-meta-description')} />
                    <meta name="keywords" content={t('lab-meta-keywords')} />
                </MetaTags>
                <div id="div-lab">
                <div className={t('lab-content-1')}></div>
                <a href={t('lab-pre-link')} target="_blank" ><div className={t('lab-content-2')}></div></a>
                    <Footer />
                </div>
            </div >



        );
    }
}

// extended main view with translate hoc
export default translate("translations")(labs);



// WEBPACK FOOTER //
// ./src/components/pages/lab.js